"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var styles = require("./NotificationPanel.css");
require("./NotificationPanel.desktop.css");
require("./NotificationPanel.mobile.css");
var NotificationPanelProps_1 = require("./NotificationPanelProps");
var Notificationstyles = require("./NotificationPanel.css");
// removed the css call
var __1 = require("../../");
var ButtonProps_1 = require("../../atoms/Button/ButtonProps");
var icons = require("../../../styles/att-icons.css");
var NotificationPanel = /** @class */ (function (_super) {
    __extends(NotificationPanel, _super);
    function NotificationPanel(props) {
        return _super.call(this, props) || this;
    }
    NotificationPanel.prototype.getNotificationIcon = function () {
        if (this.props.options.type) {
            var type = this.props.options.type;
            switch (type) {
                case NotificationPanelProps_1.NotificationType.CART_ERROR:
                    return icons.attIconBadgealert;
                case NotificationPanelProps_1.NotificationType.EMPTY_CART:
                    return icons.attIconShoppingcartL;
                case NotificationPanelProps_1.NotificationType.INFO_CART:
                    return icons.attIconInfo;
                default:
                    return icons.attIconBadgealert;
            }
        }
        else {
            return icons.attIconBadgealert;
        }
    };
    NotificationPanel.prototype.render = function () {
        var _a;
        return (React.createElement("div", null,
            React.createElement("div", { className: Notificationstyles.panelView },
                React.createElement("div", { className: styles.notificationContent },
                    this.showIcon(),
                    React.createElement("div", { className: styles.clear })),
                React.createElement("div", { className: styles.notificationContent },
                    !this.props.options.styleType && React.createElement("h1", null, this.props.data.title),
                    this.bodyContent(),
                    React.createElement("div", null,
                        this.props.data.primaryButtonLabel ?
                            React.createElement("span", { className: styles.button2 },
                                React.createElement(__1.Button, { data: { text: this.props.data.primaryButtonLabel }, events: { onClick: this.props.events.primaryButtonClick }, options: { type: this.props.data.secondaryButtonLabel ?
                                            ButtonProps_1.ButtonType.GHOST : ((_a = this.props.data) === null || _a === void 0 ? void 0 : _a.isCaribbean) ? ButtonProps_1.ButtonType.SQUARE : ButtonProps_1.ButtonType.PRIMARY } }))
                            : null,
                        this.props.data.secondaryButtonLabel ?
                            React.createElement("span", { className: styles.button1 },
                                React.createElement(__1.Button, { data: { text: this.props.data.secondaryButtonLabel }, events: { onClick: this.props.events.secondaryButtonClick } }))
                            : null)))));
    };
    NotificationPanel.prototype.validContent = function () {
        var temp = document.createElement('div');
        var content = decodeURIComponent(this.props.data.description);
        temp.innerHTML = content;
        return this.isApprovedContent(Array.prototype.slice.call(temp.querySelectorAll('*')))
            ? content : 'INVALID';
    };
    NotificationPanel.prototype.bodyContent = function () {
        if (this.props.options.isAbusiveByCustomer) {
            return (React.createElement("div", { style: { textAlign: 'left', marginLeft: '25%' } },
                React.createElement("p", { dangerouslySetInnerHTML: { __html: this.props.data.description } })));
        }
        else {
            return (React.createElement("p", { dangerouslySetInnerHTML: { __html: this.validContent() } }));
        }
    };
    NotificationPanel.prototype.isApprovedContent = function (elements) {
        // search for dis-allowed tags
        return elements.find(function (element) {
            var allowed = NotificationPanel.allowedTags[element.tagName];
            if (allowed) {
                if (Array.prototype.slice.call(element.attributes).find(function (attribute) { return allowed.indexOf(attribute.name) < 0; })) {
                    allowed = undefined; // found dis-allowed attribute
                }
            }
            return !allowed; // return true if dis-allowed element found
        }) === undefined;
    };
    NotificationPanel.prototype.showIcon = function () {
        var iconClasses = [icons.attIcon, icons.attIconLg, styles.fontLarge, this.getNotificationIcon()];
        var accessibilityText = (this.props.options.accessibilityText ?
            this.props.options.accessibilityText :
            'Icon');
        if (this.props.options && this.props.options.styleType && this.props.options.styleType === 'renny') {
            return (React.createElement("div", { className: styles.rennyC },
                React.createElement("div", { className: styles.rennyCartIcon },
                    React.createElement("i", { "aria-hidden": "true" },
                        React.createElement("svg", { "data-name": "Layer 1", viewBox: "0 -3 24 24" },
                            React.createElement("path", { d: "M21.18 2.71H6.34C6.17 1.95 6 1.23 5.86.6A.78.78 0 0 0 5.1 0H.78a.78.78\n                             0 1 0 0 1.55h3.7c2.28 10 2.34 10.23 2.34 10.23a3.72 3.72 0 0 0 2.06 2.79 1.94 1.94\n                              0 0 0 3.51 1.64 1.81 1.81 0 0 0 .18-.82 2.56 2.56 0 0 0 0-.39h3.82a1.94 1.94\n                               0 1 0 2.3-1.5.78.78 0 0 0-.22 0 .57.57 0 0 0-.18 0h-7c-1.89\n                                0-2.54-.61-2.87-1.69h11.06a1.3 1.3 0 0 0 1.28-1l1.68-6.37v-.13a1.49\n                                 1.49 0 0 0 0-.21 1.33 1.33 0 0 0-1.26-1.39z" })))),
                React.createElement("div", null,
                    " ",
                    React.createElement("h2", { className: styles.rennyTitle }, this.props.data.title))));
        }
        else {
            return (React.createElement("div", { className: styles.notificationIcon },
                React.createElement("i", { className: iconClasses.join(' '), role: "img", "aria-label": accessibilityText, tabIndex: 0 })));
        }
    };
    NotificationPanel.allowedTags = {
        A: ['href', 'id', 'class'],
        BR: [],
        DIV: ['class', 'id'],
        I: [],
        SPAN: ['class', 'id'],
        STRONG: ['id'],
        U: [],
        LI: [],
        UL: [],
    };
    return NotificationPanel;
}(React.Component));
exports.default = NotificationPanel;
//# sourceMappingURL=NotificationPanel.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/ui-components/components/panels/NotificationPanel/NotificationPanel.js
// module id = 1398
// module chunks = 8